import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { SupportHero } from "@/components/site/support/SupportHero";
import { DonateWidget } from "@/components/site/support/DonateWidget";
import { WaysToGive } from "@/components/site/support/WaysToGive";
import { ImpactSection } from "@/components/site/support/ImpactSection";
import { WfButton } from "@/components/site/primitives";
import { SiteFooter } from "@/components/site/SiteFooter";

/**
 * SupportPage — interactive donate / ways-to-give experience.
 * NOTE: content is PLACEHOLDER/filler for design-demo purposes (see content/support.js).
 * No real payment processing is connected.
 */
export default function SupportPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay linkToHome />
      <main id="content" tabIndex={-1} className="outline-none">
        <SupportHero />
        <DonateWidget />
        <WaysToGive />
        <ImpactSection />

        {/* Closing band */}
        <section aria-labelledby="support-outro-heading" className="bg-[var(--wf-cream)] py-16 sm:py-20 lg:py-24">
          <div className="wf-container">
            <div className="relative overflow-hidden rounded-sm bg-[var(--wf-farm-green)] px-6 py-14 text-center sm:px-10 sm:py-16">
              <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[var(--wf-moss)]/40 blur-2xl" />
              <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 -left-10 h-64 w-64 rounded-full bg-[var(--wf-olive)]/40 blur-2xl" />
              <div className="relative mx-auto max-w-2xl">
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[rgba(255,253,248,0.85)]">Thank you</span>
                <h2 id="support-outro-heading" className="mt-4 font-serif text-3xl font-semibold leading-[1.1] text-white sm:text-4xl">Supporting Farmers who Feed our Communities</h2>
                <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-[rgba(255,253,248,0.85)]">Have a question about giving? We would love to hear from you.</p>
                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                  <WfButton as="a" href="#donate" onClick={(e) => { e.preventDefault(); document.getElementById("donate")?.scrollIntoView({ behavior: "smooth", block: "start" }); }} variant="light" withArrow className="rounded-full px-7" data-testid="support-outro-donate-button">Donate now</WfButton>
                  <WfButton as="a" href="/" className="border border-white/60 bg-white/10 px-7 text-white backdrop-blur-sm hover:bg-white/20" data-testid="support-outro-home-button">Back to home</WfButton>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
